import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/top.png';
import _imports_1 from '@/assets/images/top-bule.png';
import _imports_2 from '@/assets/images/bom.png';

const _withScopeId = n => (_pushScopeId("data-v-7f9d9b68"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "menu-title"
};
const _hoisted_2 = {
  ref: "containerRef",
  class: "tab-list-wrapper"
};
const _hoisted_3 = {
  ref: "tabListRef",
  class: "tab-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "item-info"
};
const _hoisted_6 = {
  key: 0,
  class: "item-name"
};
const _hoisted_7 = {
  key: 0,
  class: "icon",
  src: _imports_0,
  alt: ""
};
const _hoisted_8 = {
  key: 1,
  class: "icon",
  src: _imports_1,
  alt: ""
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 0
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = {
  key: 1
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_2,
  alt: ""
}, null, -1));

const _hoisted_15 = [_hoisted_14];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["menu-item", {
      'menu-item-last': $props.isLast
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString($props.menuData.title), 1)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menuList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["tab-item", {
        'tab-item-checked': $props.checkedId == item.id,
        'tab-item-unchecked': $props.checkedId != item.id
      }]),
      onClick: $event => $options.checkedChange(item)
    }, [_createElementVNode("div", _hoisted_5, [item.children && item.children.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createTextVNode(_toDisplayString(item.name) + " ", 1), $props.checkedId != item.id ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : (_openBlock(), _createElementBlock("img", _hoisted_8))])) : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.name), 1))])], 10, _hoisted_4);
  }), 256))], 512)], 512), $options.showExpandBtn ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.expand && $options.expand(...args)),
    class: "expand-btn"
  }, [$data.expandStatus === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)) : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))])) : _createCommentVNode("", true)], 2);
}